




















import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class StartCompanyItem extends Vue {
    @Prop() icon: string | undefined;
    @Prop() title: string | undefined;
    @Prop() text: string | undefined;
}
